module.exports = __webpack_public_path__ + "static/media/ObilanaOluwatosin.4a6261ba.jpg";